import { appConfig } from './app/app.config';

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';

import { HttpClient } from '@angular/common/http';
import { enableProdMode, isDevMode } from '@angular/core';


if (!isDevMode()) {
  enableProdMode();
}

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
